module.exports = __webpack_public_path__ + "static/img/inmeeting.1bd8d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/home/meeting-room/inmeeting.png
// module id = SyEf
// module chunks = 1